'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorType = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseListCover = require('@bibliocommons/base-list-cover');

var _baseListCover2 = _interopRequireDefault(_baseListCover);

require('../styles/EditorType.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditorType = exports.EditorType = function (_BcReactComponent) {
  _inherits(EditorType, _BcReactComponent);

  function EditorType() {
    _classCallCheck(this, EditorType);

    return _possibleConstructorReturn(this, (EditorType.__proto__ || Object.getPrototypeOf(EditorType)).apply(this, arguments));
  }

  _createClass(EditorType, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _baseButtons.TextButton,
        {
          'data-test-id': this.props.testId,
          className: 'cp-editor-type',
          handleClick: this.props.handleClick },
        _react2.default.createElement(
          _baseListCover2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'editor-title' },
            this.props.title,
            _react2.default.createElement(
              'div',
              { className: 'editor-subtitle' },
              this.props.subtitle
            )
          )
        )
      );
    }
  }]);

  return EditorType;
}(_baseBcReactComponent2.default);

EditorType.propTypes = {
  title: _react2.default.PropTypes.string.isRequired,
  testId: _react2.default.PropTypes.string,
  subtitle: _react2.default.PropTypes.string,
  handleClick: _react2.default.PropTypes.func
};

exports.default = EditorType;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-type/components/EditorType.component.js
// module id = 1297
// module chunks = 0